var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEastTimor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 0C12.0831 0 8.49524 1.40856 5.71387 3.74587L22.9569 16L5.71387 28.2541C8.49524 30.5914 12.0831 32 16.0004 32C24.8369 32 32.0004 24.8365 32.0004 16C32.0004 7.1635 24.8369 0 16.0004 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.68628C-1.56212 10.9347 -1.56212 21.0653 4.68625 27.3138C7.26831 24.7317 9.75163 22.2484 16 16L4.68625 4.68628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43619 12.3347L6.87119 14.6392L9.81544 13.0352L8.37637 16.0633L10.8114 18.3679L7.48681 17.9349L6.04756 20.963L5.43212 17.6672L2.1075 17.2341L5.05162 15.6303L4.43619 12.3347Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEastTimor);
export default __webpack_public_path__ + "static/media/flag_east_timor.e4d6f79f5b76dc438598e74d3386a2af.svg";
export { ForwardRef as ReactComponent };